import { memo, useMemo } from 'react';
import { DataNotification } from '.';

function SeekNotification({
  data = [], isOpened, handleShowList, handleHideItem,
} : Readonly<{ data: DataNotification; isOpened: boolean; handleShowList: () => void; handleHideItem: (id: string) => void }>) {
  const Item = useMemo(() => (
    (data ?? []).length > 0 && data.slice(0, 3).map((item) => (
      <>
        <div
          style={{
            gap: '10px',
            width: '50px',
            height: '30px',
          }}
          aria-hidden
          onClick={() => handleHideItem(item.notification_id)}
          key={item.notification_id}
          className="d-flex flex-row justify-content-center align-items-center cursor-pointer w-100"
        >
          <div className="notification_icon" />
          <div className="seek_notification_item w-100">
            <div className="title">{item.feature}</div>
            <div className="message">
              {item.message}
            </div>
          </div>
          <div className={item.read_at ? 'read' : 'unread'} />
        </div>
        <hr className="border-separation my-2" />
      </>
    ))
  ), [data]);
  return (
    <div className={`seek_notification position-absolute d-flex justify-content-between flex-column ${isOpened && 'show'}`}>
      <div className="w-100 d-flex flex-column align-items-center justify-content-start h-fit">
        <h5 className="quicksand w-fit">Notification</h5>
        {Item}
      </div>
      <button
        id="view_all_notification"
        type="button"
        className="view-all quicksand"
        onClick={() => {
          handleShowList();
        }}
      >
        View All
      </button>
    </div>
  );
}

export default memo(SeekNotification);
